<body class="padding">
  <div id="upload_ecms">
    <ng-container *ngIf="!failFlag; then noError; else isError"></ng-container>
  </div>
</body>

<ng-template #noError>
  <ng-container *ngIf="!isUploading; then isUpload; else isSpinner"></ng-container>
</ng-template>

<ng-template #isError>
  <h2>Error uploading file!</h2>
  <span class="hubid">Please contact support</span>
</ng-template>

<ng-template #isUpload>
  <div class="editrow">
    <br />
    <label for="dispatched" class="left">Update Info</label>
    <br />
    <br />
    <div class="inline">
      <div class="block">
        <div class="field-header">Duplicate</div>
        <br />
        <mat-form-field>
          <mat-select placeholder="Select" id="duplicate" [(ngModel)]="updateList.duplicate">
            <mat-option *ngFor="let a of truefalse" [value]="a.type">{{ a.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <br />
      </div>
      <div class="block">
        <div class="field-header">FuelType</div>
        <br />
        <mat-form-field>
          <mat-select placeholder="Select" id="fuel_type" [(ngModel)]="updateList.fuel_type">
            <ng-container *ngFor="let type of fuels">
              <mat-option [value]="type.id">{{ type.type }}
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
        <br />
      </div>
      <div class="block">
        <div class="field-header">Approved</div>
        <br />
        <mat-form-field>
          <mat-select placeholder="Select" id="approved" [(ngModel)]="updateList.approved">
            <mat-option *ngFor="let a of truefalse" [value]="a.type">{{ a.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <br />
      </div>
    </div>
    <div class="inline">
      <div class="block">
        <div class="field-header">Source</div>
        <br />
        <mat-form-field>
          <mat-select placeholder="Select" id="source" [(ngModel)]="updateList.source">
            <ng-container *ngFor="let type of source">
              <mat-option [value]="type.id">{{ type.type }}
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
        <br />
      </div>
      <div class="block">
        <div class="field-header">Have Wifi</div>
        <br />
        <mat-form-field>
          <mat-select placeholder="Select" id="have_wifi" [(ngModel)]="updateList.have_wifi">
            <mat-option *ngFor="let a of truefalse" [value]="a.type">{{ a.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <br />
      </div>
      <div class="block">
        <div class="field-header">Pre2007</div>
        <br />
        <mat-form-field>
          <mat-select placeholder="Select" id="pre_2007" [(ngModel)]="updateList.built_before_2007">
            <mat-option *ngFor="let a of truefalse" [value]="a.type">{{ a.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <br />
      </div>
    </div>
    <div class="inline">
      <div class="block">
        <div class="field-header">Grant</div>
        <br />
        <mat-form-field>
          <mat-select placeholder="Select" id="grant" [(ngModel)]="updateList.previous_grant">
            <mat-option *ngFor="let a of truefalse" [value]="a.type">{{ a.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <br />
      </div>
      <div class="block">
        <div class="field-header">Timeclock</div>
        <br />
        <mat-form-field>
          <mat-select placeholder="Select" id="time_clock" [(ngModel)]="updateList.use_time_clock">
            <mat-option *ngFor="let a of truefalse" [value]="a.type">{{ a.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <br />
      </div>
      <div class="block">
        <div class="field-header">Dead Lead</div>
        <br />
        <mat-form-field>
          <mat-select placeholder="Select" id="dead_lead" [(ngModel)]="updateList.dead_lead">
            <mat-option *ngFor="let a of truefalse" [value]="a.type">{{ a.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <br />
      </div>
    </div>
    <div class="inline">
      <div class="block">
        <div class="field-header">Lead Status</div>
        <br />
        <mat-form-field>
          <mat-select placeholder="Select" id="lead_status" [(ngModel)]="updateList.lead_status_id">
            <mat-option *ngFor="let type of leadStatusList" [value]="type.lead_status_id">{{ type.lead_status_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <br />
      </div>
      <div class="block">
        <div class="field-header">Heating System</div>
        <br />
        <mat-form-field>
          <mat-select placeholder="Select" id="heating_system" [(ngModel)]="updateList.heating_system_id">
            <mat-option *ngFor="let type of heatingSystemList" [value]="type.heating_system_id">
              {{ type.heating_system_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <br />
      </div>
      <div class="block">
        <div class="field-header">Removed</div>
        <br />
        <mat-form-field>
          <mat-select placeholder="Select" id="removed" [(ngModel)]="updateList.removed">
            <mat-option *ngFor="let a of truefalse" [value]="a.type">{{ a.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <br />
      </div>
    </div>
    <div class="inline">
      <div class="block">
        <div class="field-header">Batch</div>
        <br />
        <mat-form-field>
          <input id="batch" placeholder="enter batch" matInput [(ngModel)]="updateList.installation_batch" />
        </mat-form-field>
        <br />
      </div>
      <div class="block">
        <div class="field-header">Handed To Installer</div>
        <br />
        <mat-form-field>
          <input id="handed_to_installer" placeholder="2020-03-01" matInput [(ngModel)]="updateList.handed_to_installer" />
        </mat-form-field>
        <br />
      </div>
    </div>
    <label for="dispatched" class="left">Uids</label>
    <br />
    <br />
    <div class="inline">
      <div class="block">
        <mat-form-field class="formfield">
          <textarea class="text" matInput [(ngModel)]="updateList.uids" cdkTextareaAutosize cdkAutosizeMinRows="6"
            cdkAutosizeMaxRows="6" placeholder="seperate by ,"></textarea>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="panel">
    <button mat-raised-button color="primary" id="upload_ecms" (click)="upload()"
      [disabled]="isDisabled">Update</button>
  </div>
  <div class="panel">
    <button mat-raised-button color="primary" id="upload_close" (click)="cancel()"
      [disabled]="isDisabled">Cancel</button>
  </div>
</ng-template>

<ng-template #isSpinner>
  <div class="uploader-status">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
